import { configureStore } from '@reduxjs/toolkit';
import {
  bigCommerceApi,
  loqateApi,
  avaApi,
  webhookApi,
  TemplateApi,
  talonOneApi,
  UsersApi,
  customerBlackList,
  paymentMethodApi,
  firebaseApi,
  etaApi,
  activityLogApi,
} from '@services';
import customerReducer from './slices/customer';
import errorLogReducer from './slices/error-log';
import notificationReducer from './slices/notification';
import orderReducer from './slices/order';
import productReducer from './slices/product';
import productsReducer from './slices/products';
import userReducer from './slices/users';
import { signupApi } from '@services/customer-signup/sms';
import AuthSliceReducer from './slices/authentication';

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({}).concat(
      bigCommerceApi.middleware,
      loqateApi.middleware,
      avaApi.middleware,
      etaApi.middleware,
      signupApi.middleware,
      customerBlackList.middleware,
      TemplateApi.middleware,
      talonOneApi.middleware,
      UsersApi.middleware,
      paymentMethodApi.middleware,
      firebaseApi.middleware,
      activityLogApi.middleware,
    ),
  reducer: {
    [bigCommerceApi.reducerPath]: bigCommerceApi.reducer,
    customer: customerReducer,
    errorLog: errorLogReducer,
    notification: notificationReducer,
    order: orderReducer,
    product: productReducer,
    products: productsReducer,
    activeUser: userReducer,
    [loqateApi.reducerPath]: loqateApi.reducer,
    [avaApi.reducerPath]: avaApi.reducer,
    [etaApi.reducerPath]: etaApi.reducer,
    [webhookApi.reducerPath]: webhookApi.reducer,
    [TemplateApi.reducerPath]: TemplateApi.reducer,
    [signupApi.reducerPath]: signupApi.reducer,
    [talonOneApi.reducerPath]: talonOneApi.reducer,
    [UsersApi.reducerPath]: UsersApi.reducer,
    [firebaseApi.reducerPath]: firebaseApi.reducer,
    Auth: AuthSliceReducer,
    [customerBlackList.reducerPath]: customerBlackList.reducer,
    [paymentMethodApi.reducerPath]: paymentMethodApi.reducer,
    [activityLogApi.reducerPath]: activityLogApi.reducer,
  },
});

export default store;
